module.exports = __webpack_public_path__ + "img/bos.ec96e1fa.png";